import React, { useEffect, useState, Suspense } from "react";
import HomeHeader from "containers/Home/HomeHeader/HomeHeader";
import SearchBar from "components/SearchBar/SearchBar";
import withToasts from "hoc/withToasts";
import BottomCartBar from "components/BottomCartBar/BottomCartBar";
import { connect } from "react-redux";
import { requestVMdetails } from "store/actions/vmDetails.action";
import { requestVmStock } from "store/actions/vmStock.action";
import "containers/Home/Home.css";
import {
  getCartCache,
  getURLDetails,
  getUserHashToken,
  getUserPhone,
  getVendingMachineUuid,
  initFetchInterceptor,
  preventReloadPage,
  removeDuplicatesFromProductsJson,
} from "utils/commonMethods";
import { pushItemsToCart } from "store/actions/cart.action";
import { useDispatch } from "react-redux";
import { API_KEYS } from "constants/apiEndpoints";
import { requestPostFetchApi } from "utils/apiMethods";
import { GET_VM_POLLING_TIME } from "constants/constants";
import useAuthentication from "hooks/useAuthentication";
import { requestClientDetails } from "store/actions/clientDetails.action";
import VmErrorScreen from "components/VmErrorScreen/VmErrorScreen";

//Lazy loading.
const BottomUpModal = React.lazy(() =>
  import("components/BottomUpModal/BottomUpModal")
);
const RequestProduct = React.lazy(() =>
  import("containers/Home/RequestProduct/RequestProduct")
);
const HomeProducts = React.lazy(() =>
  import("containers/Home/HomeProducts/HomeProducts")
);

const Footer = React.lazy(() => import("containers/Footer/Footer"));

function Home({
  requestVMdetails,
  requestVmStock,
  vendingMachine,
  vendingMachineItems,
  showErrorToast,
  showSuccessToast,
  vendingMachineFilters,
  requestCLdetails,
}) {
  const componentTexts = window.appTexts.home_page;
  const [productList, setProductList] = useState(null);
  const [noProducts, setNoProducts] = useState(false);
  const [showRequestProduct, setShowRequestProduct] = useState(false);
  const [vmIsOffline, setVmIsOffline] = useState(false);

  //Validations for vm is offline
  const handleVmIsOffline = function () {
    requestPostFetchApi(API_KEYS.GET_VM_DETAILS, {
      // phone_no: getUserPhone(),
      // hash: getUserHashToken(),
      query: getURLDetails(),
      uuid: getVendingMachineUuid(),
    }).then((response) => {
      //VM not found
      if (!response.vendingMachine) {
        return;
      }

      return setVmIsOffline(!response.vendingMachine.is_online);
    });
  };

  useEffect(() => {
    handleVmIsOffline();
    //Polling
    // setInterval(() => {
    //   handleVmIsOffline();
    // }, GET_VM_POLLING_TIME);
    // preventReloadPage();
  }, []);

  useEffect(() => {
    //Get Vending Machine & stock Details.
    requestVMdetails();
    requestVmStock();
    requestCLdetails();
  }, [requestVMdetails, requestVmStock]);
  const dispatch = useDispatch();
  //Store next items in redux.
  const dispatchItemsToCart = function (nextItemsInCart) {
    dispatch(pushItemsToCart(nextItemsInCart));
  };

  //Lifecycle Events
  useEffect(() => {
    if (vendingMachineItems) {
      let cachedCart = getCartCache();
      let nextItemsInCart = [];

      //Retreive cached cart data.
      if (cachedCart && cachedCart.length) {
        nextItemsInCart = cachedCart
          .map((element) => {
            //Validations to check if stock is available and item is available.
            let currentElementInVm = vendingMachineItems.find(
              (item) => item.sid === element.item.sid
            );

            //Return if item stock not available or item not found
            if (!currentElementInVm || !currentElementInVm.stk) {
              return;
            }

            //Set quantity to minimum of stock available and user specified stock.
            element.quantity = Math.min(
              element.quantity,
              currentElementInVm.stk
            );
            return element;
          })
          .filter((ele) => ele);

        //Push cached cart.
        dispatchItemsToCart(nextItemsInCart);
      }

      //Set vending machine items
      setProductList(vendingMachineItems);
    }
  }, [vendingMachineItems]);

  const handleProduct = function () {
    setNoProducts(true);
  };

  // Interceptor for fetch
  initFetchInterceptor(showErrorToast, handleProduct);

  //Controllers.
  const handleSearchBar = function (nextProductList) {
    return setProductList(nextProductList);
  };

  const toggleRequestProductPopup = function () {
    return setShowRequestProduct(!showRequestProduct);
  };

  return vmIsOffline ? (
    <VmErrorScreen
      errorMessages={window.appTexts.error_vending_machine_is_offline}
    />
  ) : (
    <div>
      <HomeHeader vmName={vendingMachine.name} />
      <section className="padded-section">
        <div className="sample_homepage_overview">
          {componentTexts.common_text.home_sample_overview}
        </div>
        <SearchBar
          data={vendingMachineItems}
          onChange={handleSearchBar}
          filterKey="name"
        />
        <Suspense fallback={<React.Fragment></React.Fragment>}>
          <HomeProducts
            noProducts={noProducts}
            data={productList}
            uniqueProductsData={removeDuplicatesFromProductsJson(
              productList,
              "iUID"
            )}
            filters={vendingMachineFilters}
            showErrorToast={showErrorToast}
            showSuccessToast={showSuccessToast}
          />
        </Suspense>
      </section>
      <Suspense fallback={<React.Fragment></React.Fragment>}>
        <BottomUpModal
          open={showRequestProduct}
          modalTitle={componentTexts.request_popup.request_popup_title}
          closeHandler={toggleRequestProductPopup}
        >
          <RequestProduct
            componentTexts={componentTexts.request_popup}
            closeHandler={toggleRequestProductPopup}
            showSuccessToast={showSuccessToast}
            showErrorToast={showErrorToast}
          />
        </BottomUpModal>
      </Suspense>

      <BottomCartBar />
    </div>
  );
}

const mapStateToProps = (state) => ({
  vendingMachine: state.vmDetailsReducer,
  vendingMachineItems: state.vmStockReducer.items,
  vendingMachineFilters: state.vmStockReducer.filters,
});

const mapDispatchToProps = (dispatch) => ({
  requestCLdetails: () => dispatch(requestClientDetails()),
  requestVMdetails: () => dispatch(requestVMdetails()),
  requestVmStock: () => dispatch(requestVmStock()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withToasts(Home));
